import React, { useState, useEffect } from "react";
import StateSelector from "./StateSelector";
import CourseHub from "./CourseHub";
import CourseReader from "./CourseReader";
import { COURSE_DATA } from "./courseData";
import Navbar from "../Navbar/Navbar";

export default function CrashCourseView({ isDarkMode, toggleTheme }) {
  const [activeStateId,  setActiveStateId]  = useState(null);
  const [activeModuleId, setActiveModuleId] = useState(null);
  const [theme, setTheme] = useState(
    () => isDarkMode !== undefined
      ? (isDarkMode ? "dark" : "light")
      : (typeof window !== "undefined" ? localStorage.getItem("theme") || "light" : "light")
  );

  // Keep internal theme in sync when parent prop changes
  useEffect(() => {
    if (isDarkMode !== undefined) setTheme(isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  const D = theme === "dark";

  const handleToggleTheme = () => {
    const next = D ? "light" : "dark";
    setTheme(next);
    localStorage.setItem("theme", next);
    document.documentElement.classList.toggle("dark", next === "dark");
    if (toggleTheme) toggleTheme();
  };

  // Scroll to top on every screen transition
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [activeStateId, activeModuleId]);

  // Security: disable right-click / print / save inside the reader
  useEffect(() => {
    if (!activeModuleId) return;
    const noCtx = (e) => e.preventDefault();
    const noKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === "p" || e.key === "s")) {
        e.preventDefault();
        alert("Security Policy: Saving and printing are disabled for this premium content.");
      }
    };
    document.addEventListener("contextmenu", noCtx);
    document.addEventListener("keydown", noKey);
    return () => {
      document.removeEventListener("contextmenu", noCtx);
      document.removeEventListener("keydown", noKey);
    };
  }, [activeModuleId]);

  const handleNextModule = () => {
    const course = COURSE_DATA[activeStateId];
    if (!course) return;
    const idx = course.modules.findIndex((m) => m.id === activeModuleId);
    if (idx !== -1 && idx + 1 < course.modules.length) {
      setActiveModuleId(course.modules[idx + 1].id);
    } else {
      setActiveModuleId(null); // back to CourseHub after last module
    }
  };

  const bg = D ? "#0d1f3c" : "#f4f7fb";

  return (
    <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", background:bg, transition:"background .3s" }}>

      {/* Site Navbar — theme toggle works across the whole page */}
      <Navbar isDarkMode={D} toggleTheme={handleToggleTheme} />

      {/* Course content */}
      <div style={{ flex:1, display:"flex", flexDirection:"column" }}>
        {!activeStateId ? (
          <StateSelector
            onSelectState={setActiveStateId}
            isDark={D}
          />
        ) : !activeModuleId ? (
          <CourseHub
            stateId={activeStateId}
            onSelectModule={setActiveModuleId}
            onBack={() => setActiveStateId(null)}
            isDark={D}
          />
        ) : (
          <CourseReader
            stateId={activeStateId}
            moduleId={activeModuleId}
            onBack={() => setActiveModuleId(null)}
            onNextModule={handleNextModule}
            isDark={D}
          />
        )}
      </div>
    </div>
  );
}
